// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"f3cbcaae","949":"80e27ce5"}[chunkId] + ".chunk.js";
};